import React, { useState, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import AuthUser from "../../services/AuthUser";
import { Modal, Table } from "react-bootstrap";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import CircularScrollProgress from "../Circularprogress";

const UserServices = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const servicesPerPage = 9; // Show 6 cards per page

    // Get current page data
    const indexOfLastService = currentPage * servicesPerPage;
    const indexOfFirstService = indexOfLastService - servicesPerPage;

    const [services, setServices] = useState([]); // Stores fetched data
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { http, token } = AuthUser();

    const [activeTab, setActiveTab] = useState("pending"); // Default tab

    const [files, setFiles] = useState([]);
    const [showModal, setShowModal] = useState(false);

    console.log(http);

    const fetchFiles = () => {

        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
            setError("User not found.");
            setLoading(false);
            return;
        }

        const email = user?.email || "default@example.com";


        http.get("/fetch-files", {
            params: {
                email: email,  // Send email as a query parameter
            }
        })
            .then((response) => {
                console.log("API Response:", response.data); // Check the response
                // Ensure response data.files is an array
                if (Array.isArray(response.data.files)) {
                    setFiles(response.data.files);
                } else {
                    console.error("Files data is not an array");
                }
                setShowModal(true); // Show modal after fetching files
            })
            .catch((error) => {
                console.error("Error fetching files:", error);
                alert("Failed to fetch files");
            });
    };

    useEffect(() => {
        // Get user details from local storage
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
            setError("User not found.");
            setLoading(false);
            return;
        }

        const email = user?.email || "default@example.com";
        const name = user?.name || "Guest";

        http.get(`/user-service-details`, { params: { email, name } })
            .then((response) => {
                console.log("API Response:", response.data);

                if (Array.isArray(response.data)) {
                    setServices(response.data); // If API returns an array
                } else if (response.data?.data) {
                    setServices(response.data.data); // If data is inside an object
                } else {
                    setServices([]); // Prevent errors if unexpected structure
                }

                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching services:", error);
                setError("Failed to load services.");
                setLoading(false);
            });
    }, []);

    if (loading) return <p className="text-center">Loading services...</p>;
    if (error) return <p className="text-center text-danger">{error}</p>;


    // Sort services by date first (latest at top)
    const sortedServices = (services || []).sort((a, b) => {
        return new Date(b.created_date) - new Date(a.created_date);
    });



    // Filter by tab
    const filteredServices = sortedServices.filter(
        (service) => service.task_status === activeTab
    );

    const currentServices = filteredServices.slice(indexOfFirstService, indexOfLastService);

    // Total pages
    const totalPages = Math.ceil(filteredServices.length / servicesPerPage);

    const handleDownload = (id) => {
        const baseUrl = process.env.REACT_APP_API_URL;  // Get the base URL from the environment variable
        // API call to download the file
        window.location.href = `${baseUrl}/api/download-file/${id}`;
    };

    const renderFilePreview = (file) => {
        const baseUrl = process.env.REACT_APP_API_URL;  // Get the base URL from the environment variable
        const fileExtension = file.files_name.split(".").pop().toLowerCase();

        if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
            return <img src={`${baseUrl}/uploads/${file.files_name}`} alt="file preview" width="100" />;
        } else if (fileExtension === "pdf") {
            return <span>PDF Icon</span>;
        } else {
            return <span>Preview Unavailable</span>;
        }
    };

    // Define a mapping for services and their respective table keys
    const serviceTableKeys = {
        "Annual Compliance (LLP)": "tblannualcompalinacellp",
        "Annual Compliance (Pvt Ltd)": "tblannualcompalinacepvtltd",
        "One Person Company Registration": "tblopccompanyregistration",
        "Other Services": "tblothers",
        "Partnership Registration": "tblpaternershipdeed",
        "Private Limited Company Registration": "tblpvtltdcompanyregistration",
        "Section Eight Company Registration": "tblsectioneightcompanyregistraion",
        "LLP Registration": "tblllpregistartion",
        "Legal Advice": "tbllegal_advice",
        "Legal Notice Reply": "tbllegalnotice_replay",
        "Legal Notice Preparation": "tbllegalnoticereparation",
        "Food License": "tblfoodlinces",
        "GST Registration": "tblgstregistration",
        "Gumasta License": "tblgumastalicense",
        "IEC (Import Export Code)": "tbliec",
        "MSME Registration": "tblmsmeregitration",
        "Trademark Services": "tbltrademarkservices",
        "Online Accounting": "tblonlineacconting",
        "ITR Filing": "tbliterfiling",
        "GST Return Filing": "tblgstreturnfilling",
        "TDS Return Filing": "tbltdsretrunfiling",


        "CMA Report": "cmareport",
        "Dissolution of Deeds": "dissolution_of_deeds",
        "Address Amendment (LLP)": "address_amendment_llp",
        "Address Amendment (Company)": "address_amendment_company",
        "Address Amendment out of state (LLP)": "address_amendment_out_of_state_llp",
        "Address Amendment out of state (Company)": "address_amendment_out_of_state_company",
        "Add Director (Company)": "add_director_company",
        "Remove Director (Company)": "remove_director_company",
        "Add Partner (Company)": "add_partner_company",
        "Remove Partner (LLP)": "remove_partner_llp",
        "Increase Capital (LLP)": "increase_capital_llp",
        "Increase Capital (Company)": "increase_capital_company",
        "Change In Name (LLP)": "change_in_name_llp",
        "Change In Name (Company)": "change_in_name_company",
        "Trust And Society Registration": "societyregistration",
        "PF And ESIC Registration": "esic_pf_registration",
        "Professional Tax Registration": "professional_tax",
        "Balance Sheet Preparation": "balancesheetpreparation",
        "Drafting Services": "drafting",
        "PF And ESIC Return Filing": "pfandesicreturn",
    };

    const fetchInvoiceHtml = (serviceId, tableKey, serviceName) => {
        const baseUrl = process.env.REACT_APP_API_URL;
        const url = `${baseUrl}/api/fetch-invoice/${serviceId}/${tableKey}/${encodeURIComponent(serviceName)}`;

        const newTab = window.open('', '_blank');

        if (newTab) {
            newTab.document.write(`
        <html>
        <head>
            <title>Loading Invoice</title>
        </head>
        <body style="
            margin:0;
            height:100vh;
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;
            font-family:sans-serif;
        ">
            <div style="
                border:4px solid #f3f3f3;
                border-top:4px solid #002866;
                border-radius:50%;
                width:40px;
                height:40px;
                animation:spin 1s linear infinite;
            "></div>

            <h3 style="margin-top:15px;">Loading invoice...</h3>

            <style>
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        </body>
        </html>
    `);

            newTab.location.href = url;
        }
    };


    const downloadInvoice = (serviceName, htmlContent, invoiceWindow) => {
        console.log("Opening invoice in a new tab...");

        // Open new tab


        // **Improved Invoice HTML with Explicit Background & Font Settings**
        const invoiceHtml = `
          <html>
          <head>
              <title>Invoice - ${serviceName}</title>
              <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js"></script>
              <script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"></script>
              <style>
                  * { box-sizing: border-box; margin: 0; padding: 0; }
                  body { 
                      font-family: Arial, sans-serif; 
                      background: #ffffff !important; /* ✅ Fix black background */
                      color: #000; /* ✅ Ensure text is visible */
                      padding: 20px; 
                  }
                  #invoiceContainer { 
                      background: #fff; /* ✅ Ensure white background */
                      padding: 20px; 
                      margin: auto; 
                      width: 80%; 
                      max-width: 800px; 
                      box-shadow: 0 0 10px rgba(0,0,0,0.1);
                      border-radius: 8px;
                      text-align: left;
                  }
                  h2 { text-align: center; margin-bottom: 20px; color: #333; }
                  table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                  th, td { border: 1px solid #ddd; padding: 10px; text-align: left; }
                  th { background: #f8f8f8; }
                  button { 
                      background: #28a745; 
                      color: white; 
                      padding: 10px 20px; 
                      border: none; 
                      cursor: pointer; 
                      margin-top: 20px; 
                      display: block;
                      width: 200px;
                      margin: 20px auto;
                      text-align: center;
                  }
                  button:hover { background: #218838; }
              </style>
          </head>
          <body>
              <div id="invoiceContainer">
                 
                  ${htmlContent}
              </div>
              <button onclick="downloadPdf()">Download PDF</button>
              
              <script>
                  async function loadImages() {
                      const images = document.querySelectorAll("img");
                      const promises = Array.from(images).map(img => new Promise(resolve => {
                          if (img.complete) resolve();
                          img.onload = resolve;
                          img.onerror = resolve;
                      }));
                      await Promise.all(promises);
                      console.log("All images loaded.");
                  }
  
                  async function downloadPdf() {
                      console.log("Starting HTML to canvas conversion...");
                      await loadImages();
  
                      html2canvas(document.getElementById("invoiceContainer"), {
                          useCORS: true,
                          allowTaint: false,
                          scale: 2.5, // ✅ Higher scale for better quality
                          backgroundColor: "#ffffff" // ✅ Ensure proper background
                      }).then(canvas => {
                          console.log("Canvas rendering complete.");
                          const imgData = canvas.toDataURL("image/png");
  
                          // ✅ Use PDF dimensions that fit A4 size
                          const pdf = new jspdf.jsPDF("p", "mm", "a4");
                          const pdfWidth = pdf.internal.pageSize.getWidth();
                          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
  
                          pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);
                          pdf.save("Invoice-${serviceName}.pdf");
                          console.log("PDF saved successfully.");
                      }).catch(error => {
                          console.error("Error generating PDF:", error);
                      });
                  }
              </script>
          </body>
          </html>
      `;

        // Write to the new tab
        invoiceWindow.document.open();
        invoiceWindow.document.write(invoiceHtml);
        invoiceWindow.document.close();
    };

    return (
        <div>
            <div className="container mt-4">
                <h2 className="mb-3">My Services</h2>

                {/* Tabs for Pending & Completed Services */}
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === "pending" ? "active" : ""}`}
                            onClick={() => setActiveTab("pending")}
                        >
                            Pending
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link  ${activeTab === "complete" ? "active" : ""}`}
                            onClick={() => setActiveTab("complete")}
                        >
                            Completed
                        </button>
                    </li>
                </ul>

                {/* Services List */}
                <div className="row mt-3">
                    {currentServices.length > 0 ? (
                        currentServices.map((service) => {
                            const tableKey = serviceTableKeys[service.service_name] || "default_table";
  // Check payment status from API
    const isPaid = Boolean(service.payment);
                            return (
                                <div key={service.id} className="col-md-4 mb-3">
                                    <Card>
                                        <Card.Body className="service-card">
                                            <Card.Title>{service.service_name}</Card.Title>
                                            <Card.Text>
                                                <strong>Service ID:</strong> {service.token}<br />
                                                <strong>Status:</strong> {service.task_status}

                                            </Card.Text>
                                            {service.task_status === "pending" && (<>
                                                <Card.Text>{service.issue || "No issue specified."}</Card.Text>

                                              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                                <Button
                                                    variant="primary"
                                                     disabled={!isPaid}
                                                    onClick={() => fetchInvoiceHtml(service.service_id, tableKey, service.service_name)}
                                                >
                                                    View Invoice
                                                </Button>

                                                <Button
                                                    variant="success"
                                                     disabled={!isPaid}
                                                    onClick={() => {
                                                        const baseUrl = process.env.REACT_APP_API_URL;

                                                        const url = `${baseUrl}/api/download-invoice/${service.service_id}/${tableKey}/${encodeURIComponent(service.service_name)}`;

                                                        window.location.href = url; // ✅ direct download
                                                    }}
                                                >
                                                    Download Invoice
                                                </Button>
                                                </div>
                                            </>
                                            )}

                                            {/* Show Download Button only if task_status is 'completed' */}
                                            {service.task_status === "complete" && (
                                                <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                                                    <Button
                                                        variant="primary"
                                                         disabled={!isPaid}
                                                        onClick={() => fetchInvoiceHtml(service.service_id, tableKey, service.service_name)}
                                                    >
                                                        View Invoice
                                                    </Button>
                                                    <Button variant="success" disabled={!isPaid} onClick={fetchFiles}>
                                                        Download
                                                    </Button>
                                                    {/* Modal for showing file list */}
                                                    <Modal show={showModal} onHide={() => setShowModal(false)}>
                                                        <Modal.Header closeButton>
                                                            <Modal.Title>Uploaded Files</Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                            <Table striped bordered hover>
                                                                <thead>
                                                                    <tr>
                                                                        <th>#</th>
                                                                        <th>File Name</th>
                                                                        <th>Preview</th>
                                                                        <th>Download</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {files.length > 0 ? (
                                                                        files.map((file, index) => (
                                                                            <tr key={file.files_id}>
                                                                                <td>{index + 1}</td>
                                                                                <td>{file.files_name}</td>
                                                                                <td>{renderFilePreview(file)}</td>
                                                                                <td>
                                                                                    <Button
                                                                                        variant="success"
                                                                                        onClick={() => handleDownload(file.files_id)}
                                                                                    >
                                                                                        Download
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="4">No files available</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </Table>
                                                        </Modal.Body>
                                                    </Modal>
                                                </div>
                                            )}
                                        </Card.Body>
                                    </Card>

                                </div>
                            );
                        })
                    ) : (
                        <div style={{
                            height: '50vh',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center'
                        }}>
                            <p className="text-center">No {activeTab} services available.</p>
                        </div>
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                        <nav>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(index + 1)}>{index + 1}</button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}

            </div>
            <div className="space40 bg-white"></div>

            <WhatsAppScrollButton />
            <Footer />
            <CircularScrollProgress />
        </div>
    );
};

export default UserServices;
